/*
 *  Every change in this enum should be reflected also in the enum in the server in "V2/DistributionTransactionPurpose"
 */
export enum DistributionTransactionPurpose {
  None = 0,
  AvailableCash = 1,
  CapitalEvent = 2,
  Dividend = 3,
  Operating = 4,
  PreferredReturn = 5,
  Promote = 6,
  Refinance = 7,
  ReturnOfCapital = 8,
  SaleOrLiquidation = 9,
  Other = 10,
  Principal = 11,
  Interest = 12,
  // Shouldn't be used
  PrincipalPlusInterest = 13,
  MultiType = 14,
  AdditionalReturn = 15,
  CatchUp = 16,
  Profit = 17,
  SemiCatchUp = 18
}


// tslint:disable-next-line:no-namespace
export namespace DistributionTransactionPurpose {
  export function toString(type: DistributionTransactionPurpose): string {
    switch (type) {

      case DistributionTransactionPurpose.AvailableCash:
        return 'Available Cash (Profit)';
      case DistributionTransactionPurpose.CapitalEvent:
        return 'Capital Event';
      case DistributionTransactionPurpose.Dividend:
        return 'Dividend';
      case DistributionTransactionPurpose.Operating:
        return 'Operating';
      case DistributionTransactionPurpose.PreferredReturn:
        return 'Preferred Return';
      case DistributionTransactionPurpose.Promote:
        return 'Promote';
      case DistributionTransactionPurpose.Refinance:
        return 'Refinance';
      case DistributionTransactionPurpose.ReturnOfCapital:
        return 'Return of Capital';
      case DistributionTransactionPurpose.SaleOrLiquidation:
        return 'Sale or Liquidation';
      case DistributionTransactionPurpose.Principal:
        return 'Principal';
      case DistributionTransactionPurpose.Interest:
        return 'Interest';
      case DistributionTransactionPurpose.Other:
        return 'Other';
      case DistributionTransactionPurpose.MultiType:
        return 'Other / Multi Type';
      case DistributionTransactionPurpose.AdditionalReturn:
        return 'Additional Return';
      case DistributionTransactionPurpose.CatchUp:
        return 'Catch Up';
      case DistributionTransactionPurpose.Profit:
        return 'Profit';
      case DistributionTransactionPurpose.SemiCatchUp:
        return 'Semi Catch Up';

      default:
        return null;
    }
  }

  export function parse(distributionTransactionPurpose: string): DistributionTransactionPurpose {
    return DistributionTransactionPurpose[distributionTransactionPurpose];
  }

  export function listAll() {
    return [
      DistributionTransactionPurpose.PreferredReturn,
      DistributionTransactionPurpose.Interest,
      DistributionTransactionPurpose.Profit,
      DistributionTransactionPurpose.ReturnOfCapital,
      DistributionTransactionPurpose.Principal,
      DistributionTransactionPurpose.Promote,
      DistributionTransactionPurpose.CatchUp,
      DistributionTransactionPurpose.AvailableCash,
      DistributionTransactionPurpose.MultiType
    ];
  }
}

export default DistributionTransactionPurpose;
